export default "__VITE_ASSET__DwAliTiu__"